import React from "react";
import classNames from "classnames";
import type { SpinnerProps } from "./types";
import styles from "./Spinner.module.css";

/**
 * Spinner component - A loading indicator for async operations.
 * Supports multiple sizes, variants, and can display a label.
 * Replaces vue-element-loading from the Vue app.
 */
export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  (
    {
      size = "md",
      variant = "primary",
      label,
      centered = false,
      fullscreen = false,
      className,
      "data-testid": testId,
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={classNames(
          styles.container,
          {
            [styles.centered]: centered,
            [styles.fullscreen]: fullscreen,
          },
          className,
        )}
        role="status"
        aria-label={label || "Loading"}
        data-testid={testId}
      >
        <div
          className={classNames(styles.spinner, styles[size], styles[variant])}
          aria-hidden="true"
        />
        {label && <span className={styles.label}>{label}</span>}
      </div>
    );
  },
);

Spinner.displayName = "Spinner";

export default Spinner;
